<zbp-modal-template
  [modalHeader]="feedbackModalHeader"
  [bodyContent]="feedbackModalBody"
  [footerContentFull]="feedbackModalFooter"
  [isScrollable]="true"
>
</zbp-modal-template>
<div id="feedbackModalContainer">
  <ng-template #feedbackModalHeader>
    <div class="modal-header">
      <h1 class="sr-only">My ZB Portal Feedback Form</h1>
      <div class="icon-title">
        <figure class="brand-logo-container">
          <img class="brand-logo-img" inert [src]="logoSrc" [alt]="logoAlt">
        </figure>
        <h4 class="modal-title" inert id="confirmationModalTitle">Feedback Form</h4>
      </div>
      <zbp-button-component theme="blackText"
                            [iconName]="zbpIconNames.x_cross"
                            ariaLabel="Close feedback form"
                            (clickHandler)="dismiss()"
      ></zbp-button-component>
    </div>
  </ng-template>
  <ng-template #feedbackModalBody>
    <div class="modal-body">
      <div class="mb-4">
        <p>Thanks for taking the time to send us feedback! We review every comment submitted and will use them to inform future portal and product enhancements.</p>
      </div>
      <label for="feedback-options" class="form-label">
        What would you like to tell us about? (required)
      </label>
      <div class="feedback-options">
        <zbp-select labelForId="feedback-options"
                    aria-required="true"
                    placeholder="Make Selection"
                    [formControl]="optionFormControl"
                    [searchable]="true"
                    [matchOptionWidth]="false"
                    [items]="feedbackOptions"></zbp-select>
        @if (optionFormControl.value === productSpecificFeedbackOption) {
          <div class="product-selection">
            <label for="product-options" class="form-label">Product (required)</label>
            <zbp-select labelForId="product-options"
                        role="combobox"
                        aria-required="true"
                        placeholder="Make Selection"
                        bindLabel="description"
                        [searchable]="true"
                        [formControl]="productFormControl"
                        [matchOptionWidth]="false"
                        [items]="productOptions"></zbp-select>
          </div>
        }
      </div>
      <div class="like-dislike">
        <label for="thumbs">How do you feel about it? (optional)</label>
        <div class="thumbs" id="thumbs">
          <zbp-button-component id="thumbsUp"
                                type="button"
                                theme="text"
                                [iconName]="thumbsUpSelected() ? zbpIconNames.thumbUpFillIcon : zbpIconNames.thumbUpOutlineIcon"
                                [iconPrimaryColor]="'var(--active-green, green)'"
                                [ariaLabel]="thumbsUpSelected() ? 'Thumbs Up Selected' : 'Thumbs Up Not Selected'"
                                (clickHandler)="updateThumbUpIcon()"
                                [iconPosition]="'left'"
                                [label]="'Like'"></zbp-button-component>
          <zbp-button-component id="thumbsDown"
                                type="button"
                                theme="text"
                                [iconName]="thumbsDownSelected() ? zbpIconNames.thumbDownFillIcon : zbpIconNames.thumbDownOutlineIcon"
                                [iconPrimaryColor]="'var(--brand-primary, red)'"
                                [ariaLabel]="thumbsDownSelected() ? 'Thumbs Down Selected' : 'Thumbs Down Not Selected'"
                                (clickHandler)="updateThumbDownIcon()"
                                [iconPosition]="'left'"
                                [label]="'Dislike'"></zbp-button-component>
        </div>
      </div>
      <div class="textarea-wrapper">
        <label for="feedbackText" class="form-label">
          Your feedback (required)
        </label>
        <textarea
          id="feedbackText"
          role="textbox"
          class="styled-textarea"
          aria-label="Feedback text area"
          aria-required="true"
          [formControl]="noteFormControl"
          [maxlength]="maxLength"
          [placeholder]="'Share your thoughts...'"
          rows="6">
        </textarea>
        <div class="char-counter"
             [class.limit-reached]="charCount >= maxLength">
          <span inert>{{ charCount }} / {{ maxLength }} Characters</span>
          <span class="sr-only-focusable">
            Character counter. {{ charCount }} used out of {{ maxLength }} characters.
          </span>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #feedbackModalFooter>
    <div class="modal-footer">
      <zbp-button-component id="submitButton"
                            type="submit"
                            label="Submit"
                            ariaLabel="Submit feedback"
                            theme="primary"
                            [disabled]="!formGroup.valid"
                            [fullWidth]="true"
                            [topBottomPaddingSpacingS]="true"
                            [showSpinner]="savingFeedback"
                            (clickHandler)="confirm()"
      ></zbp-button-component>
    </div>
  </ng-template>
</div>
